import React from 'react';

export const Greeting: React.FC<{ text: string; className: string }> = ({ text, className }) => {
  return <div className={className}>{text}</div>;
};
